import { render, staticRenderFns } from "./customerList2.vue?vue&type=template&id=2ab4218e&scoped=true&"
import script from "./customerList2.vue?vue&type=script&lang=js&"
export * from "./customerList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4218e",
  null
  
)

export default component.exports